import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { empty } from "../characters/empty";
import { mc } from "../characters/MC";
import { vanessa } from "../characters/Vanessa";
import { images } from "./images";
import { V6VanessaArrivesAfter } from "./V6";
import { doDoorRing } from "../helpers/helpers";

export const V6VanessaAtHome = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_0);
    doDoorRing();
    mc.think(`I'm coming... Give me a second.`);
    mc.think(`Is that... Vanessa?`);
	mc.think(`Crazy shit it is then.`);
    ImageClass.setImage(images.v6.VanessaArrived_1);
    mc.talk(`Hey Vanessa.`);
    mc.talk(`What are you doing here?`);
    ImageClass.setImage(images.v6.VanessaArrived_2);
    if (Game.seenScenarios.includes(`V5AnnSexEvening`)) {
        if (!Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined`)) {

            return jump(V6VanessaAtHomeAnnStatus234WithoutVanessa, "V6VanessaAtHomeAnnStatus234WithoutVanessa");
        }
        return jump(V6VanessaAtHomeAnnStatus234WithVanessa, "V6VanessaAtHomeAnnStatus234WithVanessa");

    }

    vanessa.talk(`That's the first thing you say to me?`);
    vanessa.talk(`How about: "You look lovely today Vanessa".`);
    vanessa.talk(`Or: "Damn! You look hot today Vanessa".`);
    mc.talk(`Maybe I was about to say that, you'll never know now.`);


    vanessa.talk(`Anyway, are you going to invite me inside or am I just gonna stand here all day?`);
    mc.talk(`I was...`);
    ImageClass.setImage(images.v6.VanessaArrived_3);
    vanessa.talk(`Move! I'll show myself inside.`);
    ImageClass.setImage(images.v6.VanessaArrived_4);
    mc.think(`I still have no idea what she is doing here...`);
    return jump(VanessaArrived_2, "VanessaArrived_2");

};

export const V6VanessaAtHomeAnnStatus234WithoutVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_2);
    vanessa.talk(`What do you mean: "What you are doing here?".`);
    vanessa.talk(`I came over to hear all the details.`);
    mc.talk(`Details?`);
    if (Game.seenScenarios.includes(`V5AnnSexEvening2_TellVanessa`)) {
        vanessa.talk(`Did you lose your memory?`);
        vanessa.talk(`You told me you are going to Ann's place.`);
        mc.talk(`Oh, yeah.`);
    } else {
        vanessa.talk(`I know you went to Ann's place yesterday!`);
        mc.talk(`Yeah... I did.`);
        vanessa.talk(`So! That's why I'm here.`);
    }
    ImageClass.setImage(images.v6.VanessaArrived_3);
    vanessa.talk(`Now move aside.`);
    ImageClass.setImage(images.v6.VanessaArrived_4);
    vanessa.talk(`I want all the details! Till the last drop!`);
    mc.think(`She could've called...`);
    ImageClass.setImage(images.v6.VanessaArrived_5, { transition: true });
    vanessa.talk(`So? I'm waiting.`);
    vanessa.talk(`Hit me with the details!`);
    mc.talk(`There isn't much to tell... wait. Why don't you just ask Ann what happened?`);
    vanessa.talk(`She would never tell me!`);
    ImageClass.setImage(images.v6.VanessaArrived_17);
    vanessa.talk(`She barely let me stick the dildo down her throat.`);
    ImageClass.setImage(images.v6.VanessaArrived_5);
    mc.talk(`That's not the same you know.`);
    ImageClass.setImage(images.v6.VanessaArrived_17);
    vanessa.talk(`I know. The dildo is much easier to pull off.`);
    ImageClass.setImage(images.v6.VanessaArrived_5);
    vanessa.talk(`Let me just ask the big questions.`);
    vanessa.talk(`Did you have sex?`);
    mc.talk(`We did.`);
    vanessa.talk(`Finally!`);
    ImageClass.setImage(images.v6.VanessaArrived_17);
    vanessa.talk(`How was it?`);
    ImageClass.setImage(images.v6.VanessaArrived_5);
    mc.talk(`Well. It was ok, like having sex with a virgin.`);
    vanessa.talk(`Don't talk like you had sex with a virgin before!`);
    vanessa.talk(`How was it for Ann? Did she like it?`);
    mc.talk(`I think so.`);
    vanessa.talk(`Why are you answering my questions like I'm trying to accuse you on a murder?`);
    mc.talk(`...`);
    mc.talk(`Alright, I'll elaborate.`);
    vanessa.talk(`Finally!`);

    return jump(V6VanessaAtHomeAnnStatus234WithoutVanessaDetails, "V6VanessaAtHomeAnnStatus234WithoutVanessaDetails");
};
export const V6VanessaAtHomeAnnStatus234WithVanessa = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_2);
    mc.think(`At this point I'm not surprised she is bursting in without an invitation.`);
    mc.think(`She did walk in on Ann and I yesterday... Not that I'm complaining; that shit was hot.`);

    vanessa.talk(`Speak!`);
    mc.talk(`I don't follow...`);
    vanessa.talk(`Yesterday. Ann, you then me.`);
    mc.talk(`Oh that.`);
    vanessa.talk(`Don't act like you didn't think about that all night long.`);
    mc.think(`She is not wrong...`);

    ImageClass.setImage(images.v6.VanessaArrived_3);
    vanessa.talk(`Move, let me in.`);




    ImageClass.setImage(images.v6.VanessaArrived_4);
    vanessa.talk(`I can't believe I need to let myself inside.`);
    mc.think(`She could've called...`);
    ImageClass.setImage(images.v6.VanessaArrived_5, { transition: true });
    vanessa.talk(`So? I'm waiting.`);
    vanessa.talk(`Speak!`);
    mc.talk(`It was hot, what do you want me to say?`);
    vanessa.talk(`That's it?`);
    vanessa.talk(`I want to hear the truth.`);
    vanessa.talk(`Did I disturb you?`);
    mc.talk(`That's a stupid question. It was a dream come true.`);
    ImageClass.setImage(images.v6.VanessaArrived_6);
    vanessa.talk(`I know!`);
    vanessa.talk(`It could have been even better if Ann wasn't so up tight.`);
    mc.talk(`She is changing.`);
    vanessa.talk(`Not fast enough!`);
    mc.talk(`Give her time.`);
    vanessa.talk(`I am!`);
    vanessa.talk(`Anyway, I want to hear what happened before I came.`);
    mc.talk(`Didn't Ann tell you after I left?`);
    vanessa.talk(`No, she passed out, haha.`);
    vanessa.talk(`Come on! Don't stall.`);
    mc.talk(`Are you sure you wanna hear everything?`);
    vanessa.talk(`Spill it.`);



    return jump(V6VanessaAtHomeAnnStatus234WithoutVanessaDetails, "V6VanessaAtHomeAnnStatus234WithoutVanessaDetails");
};
export const V6VanessaAtHomeAnnStatus234WithoutVanessaDetails = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_5);
    mc.talk(`Ok, so I was sitting at home and Ann called, said she wanted to meet at her place.`);
    mc.talk(`I guess that was just after you two were finished with your session or whatever.`);
    vanessa.talk(`A-ha a-ha.`);
    mc.talk(`So I went over there, and she opened the door wearing a robe.`);
    vanessa.talk(`Good girl! Just like I told her.`);
    mc.talk(`Then she started taking her clothes off. It wasn't exactly like a striptease because she wasn't dancing or anything.\nBut it was nice.`);
    vanessa.talk(`Did she wear that pink lingerie I gave her???`);
    mc.talk(`She did.`);
    vanessa.talk(`Good girl!`);
    mc.talk(`So after she removed her clothes...`);
    mc.talk(`Are you sure you want to hear EVERYTHING?`);
    vanessa.talk(`Positive!`);
    if (!Game.seenScenarios.includes(`V6VanessaAtHomeAnnStatus234WithVanessa`)) {
        vanessa.talk(`Wait.`);
        vanessa.talk(`Did she shave?`);
        mc.talk(`No, she still had a small bush. But it seems like she trimmed it.`);
        ImageClass.setImage(images.v6.VanessaArrived_6);
        vanessa.talk(`What the fuck? I told her to shave it.`);
        ImageClass.setImage(images.v6.VanessaArrived_5);
        vanessa.talk(`Ok, go on.`);
    }
    if (Game.seenScenarios.includes(`AnnRoomEvening_4_Lick`)) {
        mc.talk(`First I went down on her.`);
        mc.talk(`I know it felt good for her because she kept pushing my head toward her pussy while moaning like crazy.`);
        vanessa.talk(`Oh! Nice!`);
    }
    if (Game.seenScenarios.includes(`AnnRoomEvening_5_BJ`)) {
        if (Game.seenScenarios.includes(`AnnRoomEvening_4_Lick`)) {

            mc.talk(`Then I went on top of her while putting my dick inside her mouth.`);
        } else {

            mc.talk(`So, I went on top of her while putting my dick inside her mouth.`);
        }
        vanessa.talk(`Did she deep throat?`);
        if (ann.properties.isCorrupted) {
            mc.talk(`She did.`);
            vanessa.talk(`GOOD GIRL!`);
            vanessa.talk(`Can you believe how fast she acquired that skill?`);
            mc.talk(`Yeah, it surprised me as well.`);
            vanessa.talk(`Are you complaining?`);
            mc.talk(`Haha, not at all.`);
        } else {
            mc.talk(`She tried... But she couldn't do it.`);
            vanessa.talk(`Damn it! I tried to show her how it's done, but she couldn't do it.`);
            vanessa.talk(`Was it good at least?`);
            mc.talk(`It was fine.`);
        }

    } else {

    }

    if (Game.seenScenarios.includes(`AnnRoomEvening_4_Lick`) || Game.seenScenarios.includes(`AnnRoomEvening_5_BJ`)) {
        if (!Game.seenScenarios.includes(`AnnRoomEvening_4_Lick`)) {
            vanessa.talk(`You didn't go down on her??? That's very selfish of you.`);
            if (mc.properties.alpha >= 6) {

                mc.talk(`Fuck that.`);
            } else {

                mc.talk(`Yeah... Maybe I should have.`);
            }
        } else {

        }

        mc.talk(`So once we were done with the foreplay I penetrated her slowly.`);
        vanessa.talk(`Finally!`);
    } else {

        mc.talk(`So I got on top of her and...`);


        vanessa.talk(`What the fuck? No foreplay?`);
        if (Game.seenScenarios.includes(`V6VanessaAtHomeAnnStatus234WithVanessa`)) {

            vanessa.talk(`Good thing I showed up!`);
        }
        if (mc.properties.alpha >= 6) {

            mc.talk(`Fuck that, I just wanted to put my dick inside her already.`);
        } else {
            mc.talk(`I thought about that... But I was so horny... I just wanted to penetrate her.`);

        }

        mc.talk(`So I started penetrating her slowly.`);
        vanessa.talk(`Finally!`);
    }
    if (Game.seenScenarios.includes(`V6VanessaAtHomeAnnStatus234WithVanessa`)) {
        mc.talk(`And surprise! Vanessa opened the door.`);
        vanessa.talk(`You meant to say: "And then it started to get interesting."`);
        return jump(VanessaArrived_2, "VanessaArrived_2");
    }

    mc.talk(`It was fine. Not too intense, but I get it, it was her first time.`);
    mc.talk(`I won't lie, it didn't take me long before I came.`);
    if (Game.seenScenarios.includes(`AnnRoomEvening_5_Fuck_Belly`)) {
        mc.talk(`So I pulled out and came on her belly.`);
        vanessa.talk(`Belly? What about the face?`);
        mc.talk(`That's what I said.`);
        vanessa.talk(`Ok... Your choice.`);
    } else {

    }
    if (Game.seenScenarios.includes(`AnnRoomEvening_5_Fuck_Face`)) {
        mc.talk(`So I pulled out and came on her face.`);
        vanessa.talk(`Nice!`);
        vanessa.talk(`Did she clean your cock afterwards?`);
        if (Game.seenScenarios.includes(`AnnRoomEvening_5_Fuck_Face_Clean`)) {
            mc.talk(`I kinda made her do it, so yeah...`);
            vanessa.talk(`Great! I'm so proud of her!`);
            vanessa.talk(`Did she like getting your cum on her face?`);
            mc.talk(`I don't think so... No.`);
            vanessa.talk(`Don't worry. She will. Give her time.`);
        } else {
            mc.talk(`No... She didn't.`);
            vanessa.talk(`What the fuck... But we talked about that.`);
        }

    }
    vanessa.talk(`Finally my girl has became an adult!`);
    mc.talk(`Yeah... I guess.`);
    return jump(VanessaArrived_2, "VanessaArrived_2");
};


export const VanessaArrived_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_5);
    if (Game.seenScenarios.includes(`V6VanessaAtHomeAnnStatus234WithoutVanessaDetails`)) {
        vanessa.talk(`So! To a different topic.`);

    }
    vanessa.talk(`You know, the last time I've been in your living room was when we played that truth or dare game.`);
    mc.talk(`I remember.`);
    vanessa.talk(`It wasn't that long ago, but it feels that way.`);
    vanessa.talk(`It was fun, wasn't it?`);
    mc.talk(`Yeah it was.`);
    vanessa.talk(`So I was thinking, why not do something similar again?`);
    mc.talk(`Play that game again?`);
    vanessa.talk(`I don't care about the game.`);
    vanessa.talk(`Just get together again, the four of us.`);
    if (mc.properties.joeStatus === "enemy") {

        return jump(V6VanessaAtHomeJoeStatus6, "V6VanessaAtHomeJoeStatus6");
    }
    return jump(V6VanessaAtHomeJoeStatusNOT6, "V6VanessaAtHomeJoeStatusNOT6");

};

export const V6VanessaAtHomeJoeStatus6 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_5);
    mc.talk(`I doubt it will happen anytime soon...`);
    mc.talk(`You know, all that shit that went down with Joey.`);
    ImageClass.setImage(images.v6.VanessaArrived_6);
    vanessa.talk(`I know, I still blame you by the way. But put that aside for now.`);
    return jump(V6VanessaAtHomeEmily, "V6VanessaAtHomeEmily");
};

export const V6VanessaAtHomeJoeStatusNOT6 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_5);
    mc.talk(`It happened, just a few days ago... At Joey's birthday.`);

    ImageClass.setImage(images.v6.VanessaArrived_6);
    vanessa.talk(`We were just sitting and talking, that's boring!`);
    vanessa.talk(`Let me rephrase, it's been a while since the four of us did something interesting.`);
    ImageClass.setImage(images.v6.VanessaArrived_5);
    mc.talk(`Yeah... I guess.`);
    mc.talk(`Do you have something in mind?`);
    vanessa.talk(`Of course!`);
    vanessa.talk(`We'll invite everyone over for a gathering, but with a theme.`);
    mc.talk(`What theme?`);
    ImageClass.setImage(images.v6.VanessaArrived_17);
    vanessa.talk(`More booze less clothes.`);
    mc.talk(`I can't say I don't like it.`);
    mc.talk(`But there is one problem.`);
    ImageClass.setImage(images.v6.VanessaArrived_6);

    vanessa.talk(`Always with the problems...`);
    mc.talk(`I don't live here by myself anymore.`);

    return jump(V6VanessaAtHomeEmily, "V6VanessaAtHomeEmily");
};

export const V6VanessaAtHomeEmily = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_12);

    emily.talk(`${mc.name}, I heard the doorbell, who was that?`);
    mc.think(`Damn, I almost forgot how Emily is walking around the house...`);
    ImageClass.setImage(images.v6.VanessaArrived_13);
    vanessa.talk(`HOLY SHIT! Who are you?`);
    ImageClass.setImage(images.v6.VanessaArrived_14);
    vanessa.talk(`What the fuck is up with your body? Are you a goddess or something?`);
    ImageClass.setImage(images.v6.VanessaArrived_13);
    vanessa.talk(`Wait! Don't tell me you just came from ${mc.name}'s' room!`);
    ImageClass.setImage(images.v6.VanessaArrived_15);
    if (mc.properties.annStatus === "gf") {

        vanessa.talk(`I know that Ann is my friend, but I can't blame you.`);
        vanessa.talk(`I'm one step away from ditching Joe for her as well.`);
    } else {
        vanessa.talk(`I'm one step away from ditching Joe for her.`);

    }
    ImageClass.setImage(images.v6.VanessaArrived_13);
    emily.talk(`Haha, thank you... I guess? And no, I came from my own room. I'm his ${emily.properties.relation}.`);
    emily.talk(`And what was that about Joe? Our Joey? You must be his girlfriend, Vanessa!`);
    vanessa.talk(`It depends on you, just say the word and he is out.`);
    emily.talk(`Haha, I'll take that as a... Compliment.`);


    vanessa.talk(`You should.`);
    vanessa.talk(`I'm still amazed how ${mc.name} never mentioned you.`);
    ImageClass.setImage(images.v6.VanessaArrived_15);
    mc.talk(`We didn't have a chance to talk about personal stuff... So how could I?`);
    ImageClass.setImage(images.v6.VanessaArrived_13);
    vanessa.talk(`How couldn't you mention her? She is...`);
    ImageClass.setImage(images.v6.VanessaArrived_14);
    vanessa.talk(`PFF!`);
    ImageClass.setImage(images.v6.VanessaArrived_13);
    emily.talk(`Emily by the way.`);
    vanessa.talk(`Emily... Such a divine name.`);

    ImageClass.setImage(images.v6.VanessaArrived_15);
    emily.talk(`Anyway... ${mc.name}, I was wondering if you would like to keep me company for a few hours.`);
    ImageClass.setImage(images.v6.VanessaArrived_15.partials.VanessaArrived_15_p);
    mc.talk(`When?`);
    emily.talk(`In about ten minutes, I just need to get ready.`);
    mc.talk(`What do you have in mind?`);
    emily.talk(`You know me... Shopping!`);

    mc.talk(`Shopping...? That's so boring.`);
    emily.talk(`Come on! We'll have more time to catch up on stuff.`);
    mc.talk(`I don't know...`);
    emily.talk(`I know what!`);
    emily.talk(`I'll give you my car when you will need it! No questions asked.`);
    mc.talk(`You have a deal!`);
    emily.talk(`Haha! I knew it would work.`);
    emily.talk(`There is just something I need to do before we leave, but when you are ready just tell me and I'll get ready real fast!`);
    ImageClass.setImage(images.v6.VanessaArrived_13);
    emily.talk(`Nice to meet you Vanessa.`);
    vanessa.talk(`Can I ask you for a favor before you leave?`);
    emily.talk(`Sure.`);
    ImageClass.setImage(images.v6.VanessaArrived_13_2);
    vanessa.talk(`Can you walk away very, very slowly?`);
    emily.talk(`Nice meeting you Vanessa!`);
    vanessa.talk(`You too, goddess!`);

    return jump(V6VanessaAtHomeEmilyLeft, "V6VanessaAtHomeEmilyLeft");
};

export const V6VanessaAtHomeEmilyLeft = async (): Promise<any> => {
    ImageClass.setImage(images.v6.VanessaArrived_5);
    vanessa.talk(`So I guess you are going shopping.`);
    mc.talk(`Oh shit, did you want to do something?`);
    vanessa.talk(`What if I did? Are you going to bail on your ${emily.properties.relation}?`);
    mc.talk(`I'd find a solution, I always do.`);

    vanessa.talk(`Well, you don't need to, my plans were for the evening anyway.`);
    vanessa.talk(`I'm a night person, if you didn't realize it by now.`);
    mc.talk(`Oh, ok great.`);

    mc.talk(`So, now you understand why we can't chill here.`);
    ImageClass.setImage(images.v6.VanessaArrived_17);
    vanessa.talk(`Are you kidding me? Let's invite her to join us!`);
    mc.talk(`No way!`);
    ImageClass.setImage(images.v6.VanessaArrived_6);
    vanessa.talk(`Why not???`);
    vanessa.talk(`It can be even better than I thought!`);

    ImageClass.setImage(images.v6.VanessaArrived_5);
    mc.talk(`No! And that's final.`);

    mc.talk(`What about your place?`);
    mc.talk(`If I recall, your parents said they are always going out at nights, so you should have an empty house.`);
    ImageClass.setImage(images.v6.VanessaArrived_6);
    vanessa.talk(`You are a really party popper, do you know that?`);
    mc.talk(`Is that a yes?`);
    vanessa.talk(`Fine.`);
    vanessa.talk(`I'll tell everyone to meet at my place.`);
    mc.talk(`Great.`);
    vanessa.talk(`Not really, but I have to work with what I've got.`);
    ImageClass.setImage(images.v6.VanessaArrived_5);
    if (Game.seenScenarios.includes(`VanessaCoffee1`)) {
        vanessa.talk(`Anyway, before I'll leave, there is something I need you to do for me.`);
        vanessa.talk(`Do you remember that old guy that showed up at my work?`);
        mc.talk(`Remind me?`);
        vanessa.talk(`Come on! At the coffee shop.`);
        if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
            vanessa.talk(`He walked up on us while I was giving you the blowjob you wanted so much.`);

        } else {

            vanessa.talk(`He came inside while we were talking.`);
        }
        mc.talk(`Oh yeah... That guy...`);
        mc.talk(`What about him?`);
        vanessa.talk(`Apparently he pulled some strings and got me fired!`);
        mc.talk(`That's sucks...`);
        vanessa.talk(`That's where you come in.`);

        vanessa.talk(`I need you to help me get my job back!`);
        mc.talk(`How am I going to do that?`);
        ImageClass.setImage(images.v6.VanessaArrived_6);
		vanessa.talk(`I have no idea! Figure it out! It's your fault...`);
        if (Question.globalAnswers.v3VanessaCoffeeJustSuckIt) {
            vanessa.talk(`Plus! You owe me for keeping quiet and not saying anything to Joe.`);

        }
        mc.talk(`Why do you want that job so much? You are just a barista there...`);
        vanessa.talk(`Because I like that job, ok? Just help me get it back.`);
        mc.talk(`I guess... I'll try to think of something.`);
        ImageClass.setImage(images.v6.VanessaArrived_5);
        vanessa.talk(`Great!`);
    }
    vanessa.talk(`Ok, so I'll get going now. Cya tonight!`);

    return jump(V6VanessaArrivesAfter, "V6VanessaArrivesAfter");
};



